/**
 * React Bits → GoGo vanilla ports
 * Shiny text, count-up, spotlight cards, star border
 */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ——— Shiny / Gradient text ——— */
  document.querySelectorAll('.gogo-eyebrow').forEach((el) => {
    if (!el.classList.contains('rb-shiny')) el.classList.add('rb-shiny');
  });

  document.querySelectorAll('[data-rb-gradient]').forEach((el) => el.classList.add('rb-gradient-text'));

  /* ——— Spotlight follow cursor ——— */
  const bindSpotlight = (el) => {
    if (el.dataset.rbSpotlightBound) return;
    el.dataset.rbSpotlightBound = '1';
    el.classList.add('rb-spotlight');

    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const onMove = (e) => {
      const rect = el.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      el.style.setProperty('--mouse-x', `${x}%`);
      el.style.setProperty('--mouse-y', `${y}%`);
    };

    el.addEventListener('pointermove', onMove, { passive: true });
  };

  document.querySelectorAll('.gogo-pcard, .rb-spotlight, [data-rb-spotlight]').forEach(bindSpotlight);

  /* ——— CountUp ——— */
  document.querySelectorAll('[data-rb-count]').forEach((el) => {
    const target = Number(el.dataset.rbCount || el.textContent.replace(/[^\d.]/g, ''));
    const suffix = el.dataset.rbSuffix || '';
    const prefix = el.dataset.rbPrefix || '';
    el.classList.add('rb-count');
    if (reduce || !target) {
      el.textContent = `${prefix}${target}${suffix}`;
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        const start = performance.now();
        const dur = 1400;
        const step = (now) => {
          const t = Math.min(1, (now - start) / dur);
          const eased = 1 - Math.pow(1 - t, 3);
          const val = Math.round(target * eased);
          el.textContent = `${prefix}${val}${suffix}`;
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      },
      { threshold: 0.4 }
    );
    io.observe(el);
  });

  /* ——— Star Border / Electric ——— */
  document.querySelectorAll('.gogo-soon__badge, [data-rb-star-border]').forEach((el) => {
    el.classList.add('rb-star-border');
  });
})();
